/**
 * 테넌트 / 고객사 API 클라이언트
 */

import apiClient from './client';

export type OrgStatus = 'active' | 'inactive';

export interface Tenant {
  id: string;
  name: string;
  code: string;
  description?: string;
  status: OrgStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface Customer {
  id: string;
  name: string;
  code: string;
  tenantId: string;
  tenantName?: string;
  description?: string;
  status: OrgStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTenantInput {
  name: string;
  code: string;
  description?: string;
  status?: OrgStatus;
}

export interface CreateCustomerInput {
  name: string;
  code: string;
  tenantId: string;
  description?: string;
  status?: OrgStatus;
}

export const tenantApi = {
  async list(): Promise<Tenant[]> {
    const res = await apiClient.get<{ success: boolean; data: Tenant[] }>('/api/tenants');
    return res.data.data;
  },
  async create(input: CreateTenantInput): Promise<Tenant> {
    const res = await apiClient.post<{ success: boolean; data: Tenant }>('/api/tenants', input);
    return res.data.data;
  },
  async update(id: string, input: Partial<CreateTenantInput>): Promise<Tenant> {
    const res = await apiClient.patch<{ success: boolean; data: Tenant }>(`/api/tenants/${id}`, input);
    return res.data.data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/api/tenants/${id}`);
  },
};

export const customerApi = {
  async list(tenantId?: string): Promise<Customer[]> {
    const res = await apiClient.get<{ success: boolean; data: Customer[] }>('/api/customers', {
      params: tenantId ? { tenantId } : undefined,
    });
    return res.data.data;
  },
  async create(input: CreateCustomerInput): Promise<Customer> {
    const res = await apiClient.post<{ success: boolean; data: Customer }>('/api/customers', input);
    return res.data.data;
  },
  async update(id: string, input: Partial<CreateCustomerInput>): Promise<Customer> {
    const res = await apiClient.patch<{ success: boolean; data: Customer }>(`/api/customers/${id}`, input);
    return res.data.data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/api/customers/${id}`);
  },
};
